import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMapPin, FiInstagram, FiPhone } from 'react-icons/fi';
import { FaInstagram, FaGoogle, FaPhoneAlt } from 'react-icons/fa';

const HeaderTopbar = () => {
    return (
        <div className="topbar">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col col-lg-6 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul>
                                <li><FaGoogle /> kuyassogutma@gmail.com</li>
                                <li><FiMapPin /> Güzelevler, Yüreğir/ADANA</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-lg-6 col-sm-12 col-12">
                        <div className="contact-info">
                            <ul className="social">
                                <li>
                                    <a target="_blank" href="https://www.instagram.com/kuyassogutma?utm_source=qr&igsh=MTJ5ZWRoM2p3bHVrYw==" rel="noreferrer">
                                        <FiInstagram />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="mailto:kuyassogutma@gmail.com" rel="noreferrer">
                                        <FaGoogle />
                                    </a>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <a target="_blank" href="tel:+905333013985" rel="noreferrer">
                                        <FaPhoneAlt /> +90533 301 39 85
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderTopbar;